import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

function PodrucjeMSPIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="PodrucjeMSPIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        //@ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <rect x="2" y="2" fill="none" stroke="#E6007C" strokeWidth="4" strokeMiterlimit="10" width="96" height="96" />
      <line fill="none" stroke="#E6007C" strokeWidth="2" strokeMiterlimit="10" x1="99.5" y1="0.5" x2="0.5" y2="99.5" />
      <line fill="none" stroke="#E6007C" strokeWidth="2" strokeMiterlimit="10" x1="66.5" y1="0.5" x2="0.5" y2="66.5" />
      <line fill="none" stroke="#E6007C" strokeWidth="2" strokeMiterlimit="10" x1="99.5" y1="33.5" x2="33.5" y2="99.5" />
      <line fill="none" stroke="#E6007C" strokeWidth="2" strokeMiterlimit="10" x1="33.5" y1="0.5" x2="0.5" y2="33.5" />
      <line fill="none" stroke="#E6007C" strokeWidth="2" strokeMiterlimit="10" x1="99.5" y1="66.5" x2="66.5" y2="99.5" />
    </svg>
  </SvgIcon>
}

export default PodrucjeMSPIcon;
